import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { NavLink, withRouter } from 'react-router-dom'
import { Field, Form } from 'redux-form'
import { asyncValidate, shouldAsyncValidate } from "redux-form-yup"
import withForm from 'with/Form'

import TextField from 'components/TextField'
import SelectField from 'components/SelectField'
import Button from 'components/buttons/Button'
import FormWithActions from 'layout/FormWithActions'
import Delete from 'components/Delete'

import { LoadingBox } from 'components/LoadingSpinner'

import UsersAPI from 'api/UsersAPI'
import DivisionsAPI from 'api/DivisionsAPI'
import handleFormErrors from 'utils/handleFormErrors'

import schema from './schema'
import styles from './index.css'

@withForm({
  asyncValidate : asyncValidate(schema),
  shouldAsyncValidate
})
export default class ManagerForm extends React.Component {
  
  static propTypes = {
    form        : PropTypes.string.isRequired,
    submitLabel : PropTypes.string,
    onClose     : PropTypes.func,
    onSubmit    : PropTypes.func.isRequired,
  }

  static defaultProps = {
    onClose : () => {}
  }

  state = { 
    divisions: []
  }

  async fetchDivisions() {
    const {response} = await DivisionsAPI.list()
    this.setState({ divisions: response })
  }

  componentDidMount() {
    this.fetchDivisions()
  }

  constructor(props) {
    super(props)
  }

  render() {
    const { handleSubmit } = this.props
    return (
      <Form form={this.props.form} onSubmit={handleSubmit}>
        <FormWithActions title={this.props.title}
          actions={[
            <Button 
              key={0}
              type='button'
              color='grey'
              onClick={() => this.props.onClose()}
              >
              Cancel
            </Button>
            ,
            <Button 
              key={1}
              loading={this.props.submitting}
              type='submit'
              color='orange' 
              style={{margin: '2rem 0rem'}}>
              {this.props.submitLabel || 'Save'}
            </Button>
          ]}>
          <Field 
            name='name' 
            label='Name'
            type='text'
            component={TextField} 
            />
          <Field 
            name='email' 
            label='Email'
            type='email'
            component={TextField} 
            />
          <Field 
            name='password' 
            label='Password'
            type='password'
            component={TextField} 
            />
          <Field 
            name='division_id'
            label='Assign to division'
            component={SelectField}
            >
            <option value={null}>-</option>
            {
              this.state.divisions.map(({ id, name }) => 
                <option key={id} value={id}>{name}</option>
            )
            }
          </Field>
        </FormWithActions>
      </Form>
    )
  }
}


export class AddManagerForm extends React.Component {
    
  static propTypes = {
    onClose : PropTypes.func,
    onSubmitted: PropTypes.func,
  }

  static defaultProps = {
    onClose : () => {},
    onSubmitted: () => {}
  }

  constructor(props) {
    super(props)
    this.submit = this.submit.bind(this)
  }

  submit = async (values) => {
    const {response} = handleFormErrors(await UsersAPI.createManager(values))
    this.props.onSubmitted(response)
    this.props.onClose()
  }

  render() {
    return (
      <ManagerForm 
        form={"AddManagerForm"}
        title={"Add Manager"}
        submitLabel={"Add Manager"}
        onClose={this.props.onClose}
        onSubmit={this.submit}
        />
    )
  }
}



export class EditManagerForm extends React.Component {
    
  static propTypes = {
    id : PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
    onClose : PropTypes.func,
    onSubmitted: PropTypes.func,
  }

  static defaultProps = {
    onClose : () => {},
    onSubmitted: () => {}
  }

  state = {
    initialValues : null
  }


  api2ui(response) {
    return {
      ...response,
      division_id: (response && response.division && response.division.id) || null
    }
  }

  async componentDidMount() {
    const {response} = await UsersAPI.getUser(this.props.id)
    if (response) {
      this.setState({ initialValues: this.api2ui(response) })
    }
  }

  constructor(props) {
    super(props)
    this.submit = this.submit.bind(this)
  }

  submit = async (values) => {
    const {response} = handleFormErrors(await UsersAPI.updateManager(this.props.id, values))
    this.props.onSubmitted(response)
    this.props.onClose()
  }

  render() {
    const {initialValues} = this.state
    if (!initialValues) return <LoadingBox />
    return (
      <ManagerForm 
        initialValues={initialValues}
        form={"EditManagerForm"}
        title={"Edit Manager"}
        submitLabel={"Edit Manager"}
        onClose={this.props.onClose}
        onSubmit={this.submit}
        />
    )
  }
}


export class DeleteManagerForm extends React.Component {
    
  static propTypes = {
    id : PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
    onClose : PropTypes.func,
    onSubmitted: PropTypes.func,
  }

  static defaultProps = {
    onClose : () => {},
    onSubmitted: () => {}
  }

  constructor(props) {
    super(props)
    this.submit = this.submit.bind(this)
  }

  submit = async (event) => {
    const {response} = handleFormErrors(await UsersAPI.deleteUser(this.props.id))
    this.props.onSubmitted(response)
    this.props.onClose()
  }

  render() {
    return (
      <Delete 
        title={"Delete Manager"}
        submitLabel={"Delete Manager"}
        entityName={"this Manager"}
        onCancel={this.props.onClose}
        onConfirm={this.submit}
        />
    )
  }
}



// WEBPACK FOOTER //
// ./src/forms/Manager/index.jsx